(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ffh-brand-showcase"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ffh-brand-showcase')) customElements.define('ffh-brand-showcase',class extends HTMLElement {
  connectedCallback(){
    if(this.controller)return;
    this.controller=new AbortController();const options={signal:this.controller.signal};
    this.groups=[...this.querySelectorAll('[data-brand-group]')];this.brands=[...this.querySelectorAll('[data-brand]')];this.index=0;this.animations=[];this.transitionId=0;this.focused=false;this.visible=false;this.hovered=false;
    this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.paused=this.motion.matches;
    this.toggle=this.querySelector('[data-toggle]');
    this.querySelector('.cb-controls').hidden=this.groups.length<2;
    this.querySelector('[data-back]').addEventListener('click',()=>this.show(this.index-1),options);
    this.querySelector('[data-forward]').addEventListener('click',()=>this.show(this.index+1),options);
    this.toggle.addEventListener('click',()=>{this.paused=!this.paused;this.updateToggle();this.schedule()},options);
    this.addEventListener('pointerenter',e=>{if(e.pointerType==='touch')return;this.hovered=true;this.schedule()},options);
    this.addEventListener('pointerleave',e=>{if(e.pointerType==='touch')return;this.hovered=false;this.schedule()},options);
    this.brands.forEach((brand,index)=>{
      brand.addEventListener('pointerenter',e=>{if(e.pointerType==='touch')return;this.hovered=true;this.show(index)},options);
      brand.addEventListener('focus',()=>{if(brand.matches(':focus-visible'))this.show(index)},options);
    });
    this.addEventListener('focusin',e=>{this.focused=e.target.matches(':focus-visible');this.schedule()},options);
    this.addEventListener('focusout',()=>queueMicrotask(()=>{this.focused=this.contains(document.activeElement)&&document.activeElement.matches(':focus-visible');this.schedule()}),options);
    document.addEventListener('visibilitychange',()=>this.schedule(),options);
    document.addEventListener('shopify:block:select',e=>{const i=this.groups.findIndex(g=>g.dataset.blockId===e.detail.blockId);if(i>=0){this.paused=true;this.updateToggle();this.show(i)}},options);
    this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.schedule()},{threshold:0});this.observer.observe(this);
    this.updateToggle();this.show(0);
  }
  updateToggle(){this.toggle.setAttribute('aria-label',this.paused?this.toggle.dataset.play:this.toggle.dataset.pause);this.toggle.querySelector('span').textContent=this.paused?'▶':'Ⅱ'}
  show(i){
    if(!this.groups.length)return;
    const previous=this.index,next=(i+this.groups.length)%this.groups.length,token=++this.transitionId;
    this.animations.forEach(animation=>animation.cancel());this.animations=[];
    this.index=next;
    this.groups.forEach((group,n)=>{group.hidden=n!==next;group.inert=n!==next;group.setAttribute('aria-hidden',String(n!==next));group.style.zIndex=n===next?'1':'0'});
    this.brands.forEach((brand,n)=>brand.classList.toggle('is-active',n===next));
    this.querySelector('[data-counter]').textContent=String(next+1).padStart(2,'0')+' / '+String(this.groups.length).padStart(2,'0');
    [next,(next+1)%this.groups.length].forEach(n=>this.groups[n].querySelectorAll('img').forEach(img=>img.loading='eager'));
    if(previous!==next&&!this.motion.matches){
      const outgoing=this.groups[previous],incoming=this.groups[next],timing={duration:700,easing:'ease-in-out',fill:'both'};
      outgoing.hidden=false;
      this.animations=[outgoing.animate([{opacity:1},{opacity:0}],timing),incoming.animate([{opacity:0},{opacity:1}],timing)];
      Promise.all(this.animations.map(animation=>animation.finished)).then(()=>{
        if(token!==this.transitionId)return;
        outgoing.hidden=true;this.animations.forEach(animation=>animation.cancel());this.animations=[];
      }).catch(()=>{});
    }
    this.schedule();
  }
  schedule(){clearTimeout(this.timer);if(this.groups.length<2||this.paused||this.focused||this.hovered||!this.visible||document.hidden)return;this.timer=setTimeout(()=>this.show(this.index+1),5000)}
  disconnectedCallback(){clearTimeout(this.timer);this.transitionId++;this.animations?.forEach(animation=>animation.cancel());this.controller?.abort();this.observer?.disconnect();this.controller=null}
});
  } catch(e) { console.error(e); }
})();

})();
